<div class="content-body">
    <div class="row form-head mt-4 mx-1">
        <div>
          <a [routerLink]="['/invoices/view-my-dispute']" class="ac-goback-btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 -960 960 960"
              width="24"
            >
              <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" />
            </svg>
            Go Back
          </a>
        </div>
      </div>
    <div class="container-fluid mt-4">
        <div class="loader" *ngIf="showLoader"></div>
        <div class="row d-sm-flex  d-block align-items-center mb-4">
                <div class="d-sm-flex rowp d-block align-items-center mb-4">
                    <div class="me-auto d-sm-flex" style="align-items: center;display: -webkit-inline-box;">
                    
                    <h2 class="text-black font-w600 mb-0 ac-inv-no">Case ID: <span
                            class="font-w400 ps-2 pe-3">{{disputeDetails.CaseID}}</span></h2>

                    <a href="javascript:void(0)" class="ac-inv-paid badge btn-success pt-1"
                        style="background-color: rgb(214, 248, 210); color: rgb(2, 132, 2);">{{disputeDetails.CaseStatusName}}</a>
                             
                    </div>              
                </div>
        </div>
        
        <div class="row ">
            <div class="col-lg-12 ac-inv-head">
                <h2>Dispute Details</h2>

                <p style="border-bottom:1px solid #d1d1d1;">Details</p>

                <div class="row d-flex justify-content-between mt-4 mb-3">

                    <div class="col-sm-12 col-md-2  ac-inner-head ac-inv-head">
                        <h6>Account No.</h6>
                        <p>{{disputeDetails.BusinessPartner}}</p>
                    </div>
                    <div class="col-sm-12 col-md-2 ac-inner-head ac-inv-head">
                        <h6>Invoice No.</h6>
                        <p>{{disputeDetails.InvoiceNumber || "Not available"}}</p>
                    </div>
                     <div class="col-sm-12 col-md-2 ac-inner-head ac-inv-head">
                        <h6>Dispute Date</h6>
                        <p>{{disputeDetails.CaseCreationDate}}</p>
                    </div> 
                    <div class="col-sm-12 col-md-2 ac-inner-head ac-inv-head">
                        <h6>Dispute Amount</h6>
                        <p>{{disputeDetails.DisputeCaseCurrency | currencySymbol}}{{disputeDetails.DisputedAmount
                            |number :'1.2-2'}}</p>
                    </div>
                    <div class="col-sm-12 col-md-2 ac-inner-head ac-inv-head">
                        <h6>Reason</h6>
                        <p>{{disputeDetails.CADisputeTypeText}}</p>
                    </div>
                </div>
                <p style="border-bottom:1px solid #d1d1d1;">Attachements</p>

                <div class="row d-flex justify-content-between mt-4  mb-4">
                    <div class="col-sm-12 col-md-3 mt-3 mb-3 ac-inner-head ac-inv-head">
                        <input #myInput type="file" (change)="fileChange($event,successDisputeModal)"  placeholder="" class="form-control">
                    </div>
                    <div class=" col-lg-12 ac-inner-head ac-inv-head ac-scroll" >
                        <div *ngFor="let file of listOfAttachment" class="ac-att">   
                        <div class="ac-ellipsis"> 
                            <span>{{file.filename}}</span>
                        </div>
                        <a class="me-1 text-black ac-text-decoration" (click)="download(file, successDisputeModal)">
                            <span class="me-1">
                                <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20">
                                    <path d="M220-160q-24 0-42-18t-18-42v-143h60v143h520v-143h60v143q0 24-18 42t-42 18H220Zm260-153L287-506l43-43 120 120v-371h60v371l120-120 43 43-193 193Z" />
                                </svg>
                            </span>
                        </a>
                    </div>
                    
                    </div>
                    
                </div>
                <p style="border-bottom:1px solid #d1d1d1;">Additional Note</p>

                <div class="col-sm-12 col-md-12 ac-inner-head ac-inv-head">
                  
                    <p><textarea class="ac-addnote" placeholder="text here" [(ngModel)]="noteText"></textarea></p>
                </div>

                <div class="form-group m-4 pb-1" style="text-align: end;">
                    <button class="btn ac-btn-primary  mb-sm-0 mb-2 float-right" (click)="addNotes()" [disabled]="noteText!== undefined && noteText!== '' ?false:true">Add Note</button>

                </div>

                <h4 class="ac-noteh"><span>Note History</span></h4>
                <div class="col-sm-12 col-md-12 pt-4 ac-inner-head ac-inv-head d-flex" *ngFor="let note of disputeNotes">
                    <span><svg width="52" height="52" viewBox="0 0 52 52" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M32.4993 47.6654C33.074 47.6654 33.6251 47.4371 34.0314 47.0308C34.4377 46.6244 34.666 46.0733 34.666 45.4987V38.9987H43.3327C44.482 38.9987 45.5842 38.5421 46.3968 37.7295C47.2095 36.9168 47.666 35.8146 47.666 34.6654V8.66536C47.666 6.26036 45.716 4.33203 43.3327 4.33203H8.66602C7.51675 4.33203 6.41455 4.78858 5.60189 5.60123C4.78923 6.41389 4.33269 7.51609 4.33269 8.66536V34.6654C4.33269 35.8146 4.78923 36.9168 5.60189 37.7295C6.41455 38.5421 7.51675 38.9987 8.66602 38.9987H21.8827L29.8994 47.037C30.3327 47.4487 30.8743 47.6654 31.416 47.6654H32.4993ZM30.3327 34.6654V41.3387L23.6594 34.6654H8.66602V8.66536H43.3327V34.6654H30.3327ZM17.3327 30.332H34.666V28.1654C34.666 25.2837 28.881 23.832 25.9994 23.832C23.1177 23.832 17.3327 25.2837 17.3327 28.1654V30.332ZM25.9994 12.9987C24.8501 12.9987 23.7479 13.4552 22.9352 14.2679C22.1226 15.0806 21.666 16.1828 21.666 17.332C21.666 18.4813 22.1226 19.5835 22.9352 20.3962C23.7479 21.2088 24.8501 21.6654 25.9994 21.6654C27.1486 21.6654 28.2508 21.2088 29.0635 20.3962C29.8761 19.5835 30.3327 18.4813 30.3327 17.332C30.3327 16.1828 29.8761 15.0806 29.0635 14.2679C28.2508 13.4552 27.1486 12.9987 25.9994 12.9987Z"
                                fill="black" />
                        </svg></span>
                    <div class="ac-notetext ">
                        <h6 *ngIf="userName!==''">{{userName}}</h6>
                        <h6 *ngIf="userName===''">{{note.caseNoteCreatedByUser}}</h6>

                        <p>{{note.caseNoteText}}</p>
                        <span class="ac-notedate">{{note.caseNoteLastChangeDateTime | date: "hh:mm'Hrs', EEE , d'th' MMMM yyyy"}}</span>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <ng-template #successDisputeModal let-modal>

        <div class="modal-body">
            <div *ngIf="showLoader && !showError"><svg xmlns="http://www.w3.org/2000/svg" width="58" height="104" viewBox="0 0 58 104"
                    fill="none">
                <path d="M52 98C26.5949 98 6 77.4051 6 52C6 26.5949 26.5949 6 52 6"
                        stroke="url(#paint0_linear_313_43230)" stroke-width="12" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <defs>
                        <linearGradient id="paint0_linear_313_43230" x1="29" y1="6" x2="29" y2="98"
                            gradientUnits="userSpaceOnUse">
                            <stop stop-color="#FA783C" />
                            <stop offset="1" stop-color="#FFC800" />
                        </linearGradient>
                    </defs>
                </svg></div>
            <div *ngIf="!showLoader && !showError">
                <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72" fill="none">
                    <path
                        d="M36 0C16.2 0 0 16.2 0 36C0 55.8 16.2 72 36 72C55.8 72 72 55.8 72 36C72 16.2 55.8 0 36 0ZM28.8 54L10.8 36L15.876 30.924L28.8 43.812L56.124 16.488L61.2 21.6L28.8 54Z"
                        fill="#168007" />
                </svg>
            </div>
            <div *ngIf="showError">
                <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
    
                    <path d="M36 0C55.908 0 72 16.092 72 36C72 55.908 55.908 72 36 72C16.092 72 0 55.908 0 36C0 16.092 16.092 0 36 0ZM48.924 18L36 30.924L23.076 18L18 23.076L30.924 36L18 48.924L23.076 54L36 41.076L48.924 54L54 48.924L41.076 36L54 23.076L48.924 18Z" fill="#D30000"/>
                    </svg>
                </div>
            <h4 class="mt-3" style="font-size:24px;">{{message}} </h4>
            <p [innerHtml]="textMsg"></p>
            <button type="button" class="close btn ac-btn-outline-primary ac-butncancel" aria-label="Close"
    (click)="closeDisputePopup()">Close</button>
    
        </div>
    
    </ng-template>
